import React from 'react';
import Modal from 'react-modal';
import Settings from '../../settings/settings';
import CloseIcon from '../../components/svg/closeIcon';
import './settingsModal.css';
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '80%',
    minHeight: '80%',
    padding: '36px',
    borderRadius: '10px',
    boxSizing: 'border-box',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: '10',
  },
};

Modal.setAppElement('#root');

function SettingsModal({ onClose, forFirstTime }) {
  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Settings Modal"
    >
      <div className="popheader">
        <div className='settings-modal-header'>Calendar Settings</div>
        <span className="popheaderspan">
          <button
            className="transpBtn"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </span>
      </div>
      <div className="content">
        <Settings forFirstTime={forFirstTime} />
      </div>
    </Modal>
  );
}

export default SettingsModal;